import type { MeResponse } from "@/api/me";

/**
 * MV2-906 (canvas 06 `admin/AdminNoPermission`) — the reason a tenant admin
 * reads when they deep-link a platform-only admin surface. One sentence on
 * what the page is, one on what they manage instead, naming their client.
 * The four tabs a ClientAdmin owns are Customers · Users · Policies ·
 * Cross-client (see `AdminShell.adminTabsFor`).
 */
function tenantName(me: MeResponse): string {
  const name = (me as { client?: { name?: string } }).client?.name;
  return name ? `ClientAdmin of ${name}` : "a ClientAdmin";
}

export const PLATFORM_SURFACE_REASONS = {
  clients: (me: MeResponse): string =>
    `The client list is a platform page. As ${tenantName(me)} you manage customers, users, policies and cross-client access — those four tabs above.`,
  sites: (me: MeResponse): string =>
    `Sites are registered and configured by re:bot. As ${tenantName(me)} you ask for a new site or a change through a support ticket; your customers' sites are on their records.`,
  audit: (me: MeResponse): string =>
    `The audit log is a platform page. As ${tenantName(me)} your changes are recorded there and re:bot can share an extract on request.`,
  vendorAccounts: (me: MeResponse): string =>
    `Vendor cloud accounts are re:bot's technical layer. As ${tenantName(me)} you never manage them — ask through a support ticket if a vendor connection looks wrong.`,
} as const;
